import React from 'react';
import PropTypes from 'prop-types';

import Avatar from 'components/Avatar';

import ChatMessageStyled from './ChatMessageStyled';
import Message from './Message';
import Username from './Username';
import Time from './Time';

export class ChatMessage extends React.PureComponent {
  render() {
    return (
      <ChatMessageStyled>
        <div style={{ paddingRight: '8px' }}>
          <Avatar
            size="40px"
            name={this.props.username}
            url={this.props.avatarUrl}
            hasBorder
          />
        </div>

        <div style={{ flexGrow: '1' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Username>{this.props.username}</Username>

            <Time>
              {new Date(this.props.time).toLocaleString('ru', {
                hour: '2-digit', minute: '2-digit',
              })}
            </Time>
          </div>

          <Message>{this.props.text}</Message>
        </div>
      </ChatMessageStyled>
    );
  }
}

ChatMessage.propTypes = {
  username: PropTypes.string,
  avatarUrl: PropTypes.string,
  text: PropTypes.string,
  time: PropTypes.number,
};

ChatMessage.defaultProps = {
  username: '',
  avatarUrl: '',
  text: '',
  time: 0,
};

export default ChatMessage;
